import { useFeedbackAlertCallbacks } from 'modules/common/hooks/useFeedbackAlertCallbacks'
import { usePrefetch } from 'modules/common/hooks/usePrefetch'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { EnumRoutes } from 'modules/common/routes'
import { useRouter } from 'next/router'
import { useLoginContextDispatch } from '../contexts/LoginContext'
import { usePostChangePasswordRequestMutation } from '../mutations/usePostChangePasswordRequestMutation'

export const useChangePasswordFlow = () => {
  const { t } = useTranslation('auth-components')

  const dispatch = useLoginContextDispatch()
  const router = useRouter()

  usePrefetch([EnumRoutes.PASSWORD_CHANGE_CONFIRM])

  const { showErrorFeedbackAlert, showSuccessFeedbackAlert } =
    useFeedbackAlertCallbacks({
      errorDescription: t('changePasswordRequest.error'),
      successDescription: t('changePasswordRequest.success'),
    })

  const {
    mutate: requestChangePassword,
    isPending,
    isError: requestFailed,
  } = usePostChangePasswordRequestMutation({
    mutationOptions: {
      onSuccess: (data, variables) => {
        dispatch({
          type: 'setUser',
          payload: variables,
        })
        router.push(EnumRoutes.PASSWORD_CHANGE_CONFIRM)
        showSuccessFeedbackAlert()
      },
      onError: showErrorFeedbackAlert,
    },
  })

  return {
    requestChangePassword,
    isLoading: isPending,
    requestFailed,
  }
}
